import { render, staticRenderFns } from "./SiderNav.vue?vue&type=template&id=48048430&scoped=true"
import script from "./SiderNav.vue?vue&type=script&lang=js"
export * from "./SiderNav.vue?vue&type=script&lang=js"
import style0 from "./SiderNav.vue?vue&type=style&index=0&id=48048430&prod&rel=stylesheet%2Fless&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48048430",
  null
  
)

export default component.exports